export const environment = {
  production: false,
  apiEndpoint: "https://uat.bmsapi.wbsolution.co",
  cached : true,
  recaptcha: {
    siteKey: '6Ld0Wz0nAAAAAI_yAZ86zjylZpy2ofrMf9Mk67Ns',
  },
};
